module.exports = __webpack_public_path__ + "img/balcony.be5030ca.webp";